import { LocaleEnum } from '@amzn/fire-tv-campaign-automation-service';

// Locale-aware default titles for the quiz
export const GAMIFIED_TRAILER_DEFAULT_TITLES: Partial<Record<LocaleEnum, string>> = {
  [LocaleEnum.EN_US]: 'Trivia Time',
  [LocaleEnum.EN_GB]: 'Trivia Time',
  [LocaleEnum.EN_CA]: 'Trivia Time',
  [LocaleEnum.EN_IN]: 'Trivia Time',
  [LocaleEnum.EN_AU]: 'Trivia Time',
  [LocaleEnum.ES_US]: 'Hora de Trivia',
  [LocaleEnum.ES_MX]: 'Hora de Trivia',
  [LocaleEnum.ES_ES]: 'Hora de Trivia',
  [LocaleEnum.DE_DE]: 'Quizzeit',
  [LocaleEnum.FR_FR]: 'Le Quiz',
  [LocaleEnum.FR_CA]: 'Le Quiz',
  [LocaleEnum.IT_IT]: 'Quiz Time',
  [LocaleEnum.JA_JP]: 'クイズタイム',
};

// Locale-aware reveal text templates. {answer} is replaced with the correct option text.
export const GAMIFIED_TRAILER_REVEAL_TEMPLATES: Partial<Record<LocaleEnum, string>> = {
  [LocaleEnum.EN_US]: 'If you guessed {answer}, you are absolutely correct!',
  [LocaleEnum.EN_GB]: 'If you guessed {answer}, you are absolutely correct!',
  [LocaleEnum.EN_CA]: 'If you guessed {answer}, you are absolutely correct!',
  [LocaleEnum.EN_IN]: 'If you guessed {answer}, you are absolutely correct!',
  [LocaleEnum.EN_AU]: 'If you guessed {answer}, you are absolutely correct!',
  [LocaleEnum.ES_US]: 'Si adivinaste {answer}, ¡estás en lo correcto!',
  [LocaleEnum.ES_MX]: 'Si adivinaste {answer}, ¡estás en lo correcto!',
  [LocaleEnum.ES_ES]: 'Si adivinaste {answer}, ¡estás en lo correcto!',
  [LocaleEnum.DE_DE]: 'Wenn Sie {answer} geraten haben, liegen Sie absolut richtig!',
  [LocaleEnum.FR_FR]: 'Si vous avez deviné {answer}, vous avez tout à fait raison !',
  [LocaleEnum.FR_CA]: 'Si vous avez deviné {answer}, vous avez tout à fait raison !',
  [LocaleEnum.IT_IT]: 'Se hai indovinato {answer}, hai assolutamente ragione!',
  [LocaleEnum.JA_JP]: '{answer}と答えた方、大正解です！',
};

export const GAMIFIED_TRAILER_DEFAULT_TITLE_FALLBACK = 'Trivia Time';
export const GAMIFIED_TRAILER_DEFAULT_REVEAL_TEMPLATE =
  'If you guessed {answer}, you are absolutely correct!';

export const GAMIFIED_TRAILER_CONSTRAINTS = {
  MIN_OPTIONS: 2,
  MAX_OPTIONS: 4,
  MAX_QUESTION_LENGTH: 110,
  MAX_OPTION_LENGTH: 20,
  MAX_TITLE_LENGTH: 15,
  MAX_REVEAL_TEXT_LENGTH: 100,
  OPTION_LABELS: ['A', 'B', 'C', 'D'],
};
